export const getRefreshToken = () => {
    return localStorage.getItem("refreshToken");
};
